module.exports = __webpack_public_path__ + "img/img2-3.2ea3e86d.png";